module.exports = __webpack_public_path__ + "static/media/list_item.ef038d98.png";